<template>
  <div>
    <div class="acc-preferences__email">{{ _initialFormValues.email }}</div>

    <div class="account-pref-form-wrapper">
      <VForm
        :name="name"
        :fields="formData.fields"
        :disabled="!isValid"
        :initialValues="_initialFormValues"
      ></VForm>
    </div>

    <div class="org-general-buttons-wrapper" v-if="_isFormTouched">
      <VButton
        size="regular"
        label="Cancel"
        extraClass="org-settings-general-cancel"
        @click="_cancel"
        inverted
      >
      </VButton>

      <VButton
        size="regular"
        label="Save"
        extraClass="org-settings-general-save"
        @click="_saveSettings"
      >
      </VButton>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapGetters, mapActions } from "vuex";

import VForm from "@/components/VForm";

// mixins
import withForm from "@/mixins/withForm";
import withToasted from "@/mixins/withToasted";
import withValidation from "@/mixins/withValidation";

import { required } from "@/utils/validations";

export default Vue.component("AccountPreferencesForm", {
  props: {
    initialValues: VueTypes.any
  },

  components: {
    VForm
  },

  mixins: [withForm, withToasted, withValidation],

  data() {
    return {
      name: "accountPreferencesForm"
    };
  },

  methods: {
    _cancel() {
      this._initializeForm();
      this.clearFormErrors();
      this.setFormTouchedValue();
    },

    _saveSettings() {
      this.validateForm();

      if (this.isValid) {
        this.updateUser({
          values: this.formValues,
          onSuccess: () => {
            this.setFormTouchedValue();
            this.successToast("Account info has been saved");
          }
        });
      }
    },

    _initializeForm() {
      this.initializeForm({
        formName: this.name,
        fields: this._initialData
      });
    },

    ...mapActions("account", ["updateUser"])
  },

  computed: {
    formData() {
      return {
        fields: [
          {
            name: "first_name",
            label: "First Name",
            placeholder: "First Name",
            isRequired: true,
            validate: [
              required,
              this.validatePairStringLength(
                40,
                "first_name",
                "last_name",
                this.name
              )
            ]
          },
          {
            name: "last_name",
            label: "Last Name",
            placeholder: "Last Name",
            isRequired: true,
            validate: [
              required,
              this.validatePairStringLength(
                40,
                "first_name",
                "last_name",
                this.name
              )
            ]
          }
        ]
      };
    },

    _initialData() {
      const { first_name, last_name, email } = this.getUser;
      return { first_name, last_name, email };
    },

    _isFormTouched() {
      return this.isFormTouched();
    },

    _initialFormValues() {
      return this.initialValues ? this.initialValues : this._initialData;
    },

    ...mapGetters("account", ["getAccount", "getUser"])
  }
});
</script>

<style lang="scss" scoped>
$ns: "acc-preferences";
$max-width: 560px;

.#{$ns} {
  &__email {
    font-size: 20px;
    font-family: Lato-Bold, sans-serif;
    color: $secondary-text-color;
    margin-bottom: 30px;
  }
}

/deep/ form {
  flex-direction: column;
}

/deep/ .input-container,
/deep/ .v-select {
  max-width: $max-width;
  margin-bottom: 42px;

  &:last-child {
    margin-bottom: 0;
  }
}

/deep/ button.inverted.org-settings-general-cancel {
  width: 70px;
  max-width: 70px;
  min-width: auto;
  border: none;
  margin-right: 30px;
}

.org-general-buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
  max-width: $max-width;
}

.account-pref-form-wrapper {
  margin-bottom: 30px;
}
</style>
